//action types for CUSTOM_PLAN

export const GET_ALL = "GET_ALL_CUSTOM_PLANS";
export const GET_ALL_SUCCESS = "GET_ALL_CUSTOM_PLANS_SUCCESS";
export const GET_ALL_FAILURE = "GET_ALL_CUSTOM_PLANS_FAILURE";

export const GET = "GET_CUSTOM_PLAN";
export const GET_SUCCESS = "GET_CUSTOM_PLAN_SUCCESS";
export const GET_FAILURE = "GET_CUSTOM_PLAN_FAILURE";

export const ADD = "ADD_CUSTOM_PLAN";
export const ADD_SUCCESS = "ADD_CUSTOM_PLAN_SUCCESS";
export const ADD_FAILURE = "ADD_CUSTOM_PLAN_FAILURE";

export const EDIT = "EDIT_CUSTOM_PLAN";
export const EDIT_SUCCESS = "EDIT_CUSTOM_PLAN_SUCCESS";
export const EDIT_FAILURE = "EDIT_CUSTOM_PLAN_FAILURE";

export const DELETE = "DELETE_CUSTOM_PLAN";
export const DELETE_SUCCESS = "DELETE_CUSTOM_PLAN_SUCCESS";
export const DELETE_FAILURE = "DELETE_CUSTOM_PLAN_FAILURE";
